import { render, staticRenderFns } from "./tagModel.vue?vue&type=template&id=b61abb42&scoped=true&lang=pug&"
import script from "./tagModel.vue?vue&type=script&lang=js&"
export * from "./tagModel.vue?vue&type=script&lang=js&"
import style0 from "./tagModel.vue?vue&type=style&index=0&id=b61abb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61abb42",
  null
  
)

export default component.exports